/* wsapi3-categories v1.0 */
/* Deploy Version 2026-10-14 10:42:30 */
/* Deploy Version 2026-09-24 19:11:09 */
/* Deploy Version 2026-07-27 16:11:01 */
wsMain.createModule({
  name: 'categorias',
  version: '1.0',
  updatedAt: '2026-07-14',
  onlyAfter: 'info-lojas',
  function: 'get',
  options: {
      megaMenu: true
  },
  async get() {
    if (!document.querySelector('[data-wsjs-module=categorias]')) return true;
    let data = await ApiWS.Calls.ListaCategorias();

    document.querySelectorAll('[data-wsjs-module=categorias]').forEach(tag => {
       wsMain.modules['categorias'].create(data, tag);
    });

    wsMain.addons.headerFirstLoad();

    return true;
  },
  create(returnJson, tag) {
      let configs = wsMain.options[this.name],
          categorias = returnJson.Categorias,
          categoriasCustom = returnJson.MenuPersonalizado;

      let options = wsMain.tools.getWsData(tag, 'options');

      // Se o SSR já rodou, a árvore que ele injetou vem marcada com data-ws-rendered — remove
      // antes de capturar "text" (conteúdo customizado a preservar), senão ela seria lida como
      // customização e colada de novo abaixo, duplicando o menu inteiro.
      let ssrRendered = tag.querySelector(':scope > ul.nav-menu-list[data-ws-rendered]');
      if (ssrRendered) ssrRendered.remove();
      let text = tag.innerHTML;

      let arrCat;

      if (!options.atual && options.custom != false && (Array.isArray(categoriasCustom) && categoriasCustom.length > 0)) {
          categoriasCustom.forEach(elm => {
              if (elm.nome.trim().toString().toLowerCase() == 'categorias') elm.subcategorias = categorias;
          });
          arrCat = categoriasCustom;
      } else if (Array.isArray(categorias) || categorias.length > 0) {
          arrCat = categorias;
      } else {
          return;
      }
      let arrLvl = 0;
      function search(mainArr, catToSearch) {
        function searchInsideSubCat(arr, lvl = 0, parent = false) {
          let response;
          arr.forEach(cat => {
            let subCat = searchInsideACat(cat, lvl, parent);
            response = subCat ? subCat : response;
          });
          
          return response;
        }
      
        function searchInsideACat(cat, lvl, parent) {
          if (catToSearch) {
            if (cat.id == catToSearch) return [cat, lvl, parent];
          } else {
            if (cat.atual) return [cat, lvl, parent];
          }

          if (cat.subcategorias && cat.subcategorias.length > 0) return searchInsideSubCat(cat.subcategorias, lvl+1, cat);
      
          return;
        }
      
        return searchInsideSubCat(mainArr);
      };

      if (options.atual) {
        let searchResult = search(arrCat, document.querySelector('#HD_CAT_ID').value);

        if (searchResult) {
          arrLvl = searchResult[1];
          arrCat = searchResult[2] ? searchResult[2].subcategorias : searchResult[0].subcategorias;

          if (arrCat.length == 0 && arrLvl != 0) {
            arrCat = searchResult[0].subcategorias || 0;
          }
        } else {
          arrCat = [];
        }
      }

      if (options.allCats  || options.mobile) {
        let objToUse = {
          atual: false,
          id: 'allCats-menu',
          nome: 'Todos os departamentos',
          produtodestaque: false,
          subcategorias: JSON.parse(JSON.stringify(arrCat))
        };

        if (options.allCats) arrCat.unshift(objToUse);
        if (options.mobile) arrCat = [objToUse];
      }

      let divMain = wsMain.tools.createElm({
        type: 'div',
        innerHTML: text,
        attrs: {
          class: options.defaultCat == false ? '' : 'nav-menu'
        }
      });

      let ulMain = wsMain.tools.createElm({
        type: 'ul', 
        attrs: {
          class: 'nav-menu-list'
        }
      });

      let title = wsMain.tools.createElm({
        type: 'div', 
        attrs: {
          class: 'sub-title'
        }
      });


      let subTitle = wsMain.tools.createElm('a');
      
      let titleLink = wsMain.tools.createElm({
        type: 'div', 
        innerHTML: 'Voltar', 
        attrs: {
          onclick: 'this.parentNode.parentNode.classList.remove("active")'
        }
      });

      title.append(subTitle);
      title.append(titleLink);

      function createTitle(div, catLink, catName) {
          let clone = div.cloneNode(true);
          clone.querySelector('a').setAttribute('href', catLink);
          clone.querySelector('a').innerHTML = catName;
          return clone;
      }
      
      function createCatList(cat, n = 0, _visited = new Set()) {
        if (cat.id != "allCats-menu" && cat.tipo == 'dpt' && cat.registro && cat.registro != 0) {
          try {
            cat = search(returnJson.Categorias, cat.registro)[0];
          } catch(err) {
            return '';
          }
        }

        if (!cat) return '';

        const _catKey = String(cat.id ?? cat.registro ?? cat.nome ?? n);
        if (_visited.has(_catKey)) return '';
        const _childVisited = new Set(_visited);
        _childVisited.add(_catKey);
        if (cat.tipo == 'inst') wsMain.globalData.infoLoja.menuinstitucional.forEach((int) => {
          if (cat.registro == int.id) cat.url = int.url;
        });

        if (cat.registro == 0) {
          cat = {
            atual: false,
            id: 'allCats-custom',
            nome: cat.nome,
            produtodestaque: false,
            subcategorias: JSON.parse(JSON.stringify(categorias))
          }
        }

          let li = wsMain.tools.createElm({type: 'li', attrs: {
              class: 'dpt-' + n + ' nav-menu-item',
              id: 'departamento-' + cat.id,
          }});


          if (n == 0 && options.allCats && cat.id == 'allCats-menu') {
            li.classList.add('dpt-all');
            li.style.display = 'none';
          }
          
          if (options.mobile && n == 1 && cat.id == 'allCats-menu') {
            return '';
          } 
          
          let hiperLink = wsMain.tools.createElm({
            type: 'a', 
            innerHTML: cat.nome, 
            attrs: {
                class: 'nav-menu-hiperlink',
                title: cat.nome || 'Todas as Categorias',
                href: cat.url || 'javascript:;'
            }
          });
          

          li.append(hiperLink)

          let subCats = cat.subcategorias;
          if (subCats && Array.isArray(subCats) && subCats.length > 0) {
            if (options.hoverMode == false && options.dropDown != true || options.mobile) {
              hiperLink.setAttribute('href', 'javascript:;');
              hiperLink.setAttribute('onclick', 'wsMain.modules["categorias"].selectMode(this)');
              hiperLink.classList.add('has-sub');

              // n === 0 é a lista raiz de departamentos — não faz sentido "Ver Tudo" ali (não
              // existe uma página que junte todos os departamentos). Só a partir de n > 0
              // (dentro de um departamento/categoria já selecionado) é que faz sentido.
              if (n > 0 && subCats[0].holder != true) {
                // id distinto do pai: o cycle-guard (_visited/_catKey, linha ~158) usa
                // String(cat.id ?? ...) e o pai já marcou seu próprio id como visitado antes
                // de recursar nos filhos — reusar cat.id aqui faz esse nó sintético ser
                // descartado silenciosamente (createCatList retorna '' por "já visitado").
                subCats.unshift({
                  nome: 'Ver Tudo',
                  holder: true,
                  id: cat.id + '-verTudo',
                  url: cat.url
                });
            }

            } else {
              li.classList.add('hover');
            }

            let ul = wsMain.tools.createElm({type: 'ul', attrs: {class: 'nav-menu-sub-list'}});
            let divHolder = wsMain.tools.createElm({type: 'div', attrs: {class: n == 0 ? 'nav-menu-main' : 'nav-menu-sub-container'}});
                for (let i = 0; i < subCats.length; i++) {
                    ul.append(createCatList(subCats[i], n+1, _childVisited));
                }
                if (n != 0) {
                    let titleList = createTitle(title, cat.url, cat.nome);
                    if (options.dropDown != true) divHolder.append(titleList);
                }
                divHolder.append(ul);
            if (n > 0 && options.hoverMode != false) {
                hiperLink.classList.add('has-sub');
                let spanLink = wsMain.tools.createElm({
                  type: 'span', 
                  attrs: {
                    'data-wsjs-icon': 'arrow'
                  }
                });
                hiperLink.append(spanLink);
                if (options.dropDown != true) {
                  hiperLink.setAttribute('href', 'javascript:;');
                  hiperLink.addEventListener('click', (e) => {
                    let subContainer = hiperLink.parentNode.querySelector('.nav-menu-sub-container');
                    if (subContainer) subContainer.classList.add('active');
                  });
                }
            }

            if (n == 0 && options.dropDown == true) divHolder.classList.add('dropdown');
            if (options.dropDown == true) hiperLink.classList.add('dropdown');

            if (n > 0 && options.dropDown != true) {
              divHolder.append(wsMain.tools.createElm({
                type: 'div',
                attrs: {
                  class: 'nav-menu-overlay'
                }
              }));
            }
            
            li.append(divHolder);
            
            if (options.dropDown == true) li.classList.add('dropdown');
          }

          if (subCats && Array.isArray(subCats) && subCats.length > 0 && configs.megaMenu && cat.produtodestaque && options.megaMenu != false && options.dropDown != true) {
            let megaMenu = wsMain.tools.createElm({
                type: 'div',
                attrs: {
                    class: 'nav-menu-megamenu-container'
                }
            });
            let img = wsMain.tools.createElm({
                type: 'img',
                attrs: {
                  class: 'nav-menu-megamenu-item-image',
                  src: cat.produtodestaque.imagem
                }
            });
            let prodDestaqueName = wsMain.tools.createElm({
                type: 'div',
                attrs: {
                  class: 'nav-menu-megamenu-item-nome-container'
                },
                innerHTML: '<p>' + cat.produtodestaque.nome + '</p>'
            });
            let prodDestaqueContainer = wsMain.tools.createElm({
              type: 'a',
              attrs: {
                href: cat.produtodestaque.url,
                class: 'nav-menu-megamenu-item'
              }
            });
            let imgHolder = wsMain.tools.createElm({
              type: 'div', 
              attrs: {
                class: 'nav-menu-megamenu-item-image-container'
              }
            });

            let photowrap = '{photowrap}';
            let aspectRatio = '1/1';
            if ( photowrap == 'Quadrada') { 
              aspectRatio = '1/1'; 
            }
            if ( photowrap == 'Vertical') { 
              if (photo) photo = photo.replace('/PEQ_', '/MED_');
              console.log(photo);
              aspectRatio = '3/4'; 
            }
            if ( photowrap == 'Super Vertical') { 
              if (photo) photo = photo.replace('/PEQ_', '/MED_');
              console.log(photo);
              aspectRatio = '2/3'; 
            }
            if ( photowrap == 'Horizontal') { 
              aspectRatio = '4/3'; 
            }

            imgHolder.style.setProperty('aspect-ratio', aspectRatio);

            imgHolder.append(img);
            prodDestaqueContainer.append(imgHolder);
            prodDestaqueContainer.append(prodDestaqueName);
            megaMenu.append(prodDestaqueContainer);
            li.append(megaMenu);
          }


          return li;
      }
      
      for (let i = 0; i < arrCat.length; i++) {
          ulMain.append(createCatList(arrCat[i]));
      }

      if ((arrCat.length == 0 && arrLvl == 0)) {
        tag.remove();
      } else {
      divMain.append(ulMain);

      wsMain.tools.replaceSpanTag(divMain, tag);
      let maxWidth = ulMain.offsetWidth;



      ulMain.querySelectorAll(':scope .dpt-1 .nav-menu-hiperlink.dropdown').forEach(elm => {
        elm.addEventListener('mouseover', () => {
          let offset = elm.offsetTop;
          elm.nextSibling.style.top = offset + 'px';
          elm.nextSibling.style.display = 'block';
          setTimeout(() => {
            elm.nextSibling.style.opacity = '1';
          }, 1);
          setTimeout(() => {
            elm.nextSibling.style.top = offset + 'px';
            elm.nextSibling.style.display = 'block';
            setTimeout(() => {
              elm.nextSibling.style.opacity = '1';
            }, 1);
          }, 200);
        });
        
        elm.addEventListener('mouseout', () => {
            setTimeout(() => {
            elm.nextSibling.style.opacity = '';
            elm.nextSibling.style.display = '';
          }, 200);
        });
      });

      ulMain.addEventListener('mouseleave', () => { 
        ulMain.querySelectorAll('.nav-menu-sub-container.active').forEach(elm => elm.classList.remove('active'));
        ulMain.querySelectorAll('li:not(.dpt-0) > .nav-menu-hiperlink.active').forEach(elm => elm.classList.remove('active'));
      });
      let menuItens = ulMain.querySelectorAll('.nav-header .dpt-0');
      
      function getWidth() {
        menuItens = ulMain.querySelectorAll('.nav-header .dpt-0');
        let width = 0, gap = getComputedStyle(ulMain).getPropertyValue('column-gap');
        gap = gap && gap != 'normal' ? gap : 0;
        menuItens.forEach((elm, i) => width += elm.querySelector(':scope > a').offsetWidth + (i == menuItens.length-1 ? 0 : parseInt(gap)));
        return width;
      }

      let permanentCategories = options ? options['always-visible']?.split(',').map(a => a.trim()) || false : false;

      while (getWidth() > maxWidth) {
        try {
          ulMain.querySelector('.dpt-all').style.display = '';
        } catch(err) {}

        if (permanentCategories) {
          for (let p = menuItens.length - 1; p >= 0; p--) {
            let isEqual = false;

            permanentCategories.forEach(pCategorie => isEqual = 'departamento-' + pCategorie == menuItens[p].getAttribute('id') ? true : isEqual);
            
            if (!isEqual) {
              menuItens[p].remove();
              break;
            } 
          }
        } else {
          menuItens[menuItens.length -1].remove();
        }
      }

try {
      ulMain.querySelectorAll(':scope > li').forEach(elm => {
        let menuMain = elm.querySelector(':scope > .nav-menu-main');
        let megaMenu = elm.querySelector(':scope > .nav-menu-megamenu-container');

        let offsetMenuMain = menuMain.getBoundingClientRect();
        let offsetMegaMenu = menuMain.getBoundingClientRect();

        if (megaMenu) {
          if (offsetMenuMain.left + menuMain.offsetWidth + megaMenu.offsetWidth + 20 > window.innerWidth) {
            elm.classList.add('alignToRight');
            elm.querySelector(':scope > .nav-menu-main').style.marginRight = '30rem';
          }
        } else {
          if (offsetMegaMenu.left + menuMain.offsetWidth + 20 > window.innerWidth) {
            elm.classList.add('alignToRight');
          }
        }
      });
} catch (err) {

}
      }

      return true;
  },
  selectMode(elm) {
    try {
      if (elm != elm.parentNode.querySelector('.active')) {
        elm.parentNode.parentNode.querySelector('.active').classList.remove('active');
      }
    } catch(_) {}

    elm.classList.toggle('active');
  }
});

/*
 * Carrossel de categorias — fotos das categorias (campo `image` do /store/category/list).
 * Fica no mesmo módulo do menu (wsapi3-categories, etapa "*" em todo tema), mas é um módulo JS
 * próprio: o nome (categorySlider) é o data-wsjs-sectype do elemento "Carrossel de categorias"
 * do editor drag-and-drop, que chama wsMain.modules[sectype].get() ao soltar a seção.
 *
 * Âncora (qualquer página):
 *   <span data-wsjs-module="category-slider" data-ws-render="server"
 *         data-wsjs-options="showName: true;"
 *         data-wsjs-slide="slides.perView: 5; slides.spacing: 20;"></span>
 *
 * Entram todas as categorias e subcategorias (qualquer nível) que tenham foto, na ordem da
 * árvore (pai antes dos filhos). Clique = link da categoria.
 *
 *   showName — true (padrão): nome por cima da foto no hover (em tela de toque, sem hover, fica
 *              sempre visível); "always": sempre visível; false: sem nome
 *   limit    — máximo de categorias (padrão: todas)
 *   slide    — false vira grade simples, sem carrossel
 *   imgArea  — área do imageResize/imageDimensions do head (padrão "categories")
 *
 * Slide: o padrão vem do dispositivo e o data-wsjs-slide da âncora sobrescreve chave a chave —
 * desktop 5 por vez, setas, sem bolinhas; mobile 2,5 por vez, sem setas nem bolinhas (a foto
 * cortada já indica que rola).
 *
 * O servidor (CategoriesServerRenderService.renderSliderAnchors) entrega só a "primeira página"
 * de fotos pra reservar a altura; aqui sempre se reconstrói do zero (mesmo trade-off do
 * wsapi3-blog-slider). Mesmo markup de card e mesmos padrões do servidor — manter em sincronia.
 */
wsMain.createModule({
  name: 'categorySlider',
  version: '1.0',
  updatedAt: '2026-10-14',
  function: 'get',

  DEFAULT_SLIDE: {
    D: { slides: { perView: 5, spacing: 20 }, arrows: true, dots: false },
    M: { slides: { perView: 2.5, spacing: 12 }, arrows: false, dots: false },
  },

  async get() {
    const tags = document.querySelectorAll('[data-wsjs-module="category-slider"]');
    if (!tags || tags.length == 0) return true;

    const self = wsMain.modules['categorySlider'];
    let data;
    try {
      data = await ApiWS.Calls.ListaCategorias();
    } catch (err) {
      console.error('[category-slider] falha ao buscar categorias:', err);
      return true;
    }

    const items = self.collect(data && data.Categorias);
    tags.forEach(t => {
      try {
        self.create(items, t);
      } catch (err) {
        console.error('[category-slider] falha ao montar carrossel:', err);
      }
    });

    return true;
  },

  // Achata a árvore (pai antes dos filhos) ficando só com quem tem foto.
  collect(tree) {
    const out = [];
    const seen = new Set();
    (function walk(list) {
      (Array.isArray(list) ? list : []).forEach(c => {
        if (!c || seen.has(String(c.id))) return;
        seen.add(String(c.id));
        if (String(c.imagem || '').trim() && c.url) out.push(c);
        walk(c.subcategorias);
      });
    })(tree);
    return out;
  },

  _device() {
    return document.querySelector('#HD_VRS_MOBILE')?.value?.toLowerCase() === 'true' ? 'M' : 'D';
  },

  // Padrão do dispositivo + data-wsjs-slide da âncora por cima, chave a chave.
  slideOptions(elm) {
    const self = wsMain.modules['categorySlider'];
    const base = JSON.parse(JSON.stringify(self.DEFAULT_SLIDE[self._device()]));
    const own = wsMain.tools.getWsData(elm, 'slide') || {};
    (function merge(src, dst) {
      Object.keys(src).forEach(k => {
        if (src[k] && typeof src[k] == 'object') {
          if (!dst[k] || typeof dst[k] != 'object') dst[k] = {};
          merge(src[k], dst[k]);
        } else {
          // getWsData devolve número como texto ("2.5")
          dst[k] = typeof src[k] == 'string' && src[k].trim() !== '' && !isNaN(src[k]) ? parseFloat(src[k]) : src[k];
        }
      });
    })(own, base);
    return base;
  },

  _nameMode(options) {
    const v = options.showName;
    if (v === false || v === 'false') return 'none';
    if (v === 'always') return 'always';
    return 'hover';
  },

  _esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  },

  // Mesmos src/srcset/sizes/width/height que o SSR gera pra <img data-ws-img="categories">.
  _photo(cat, imgArea) {
    const esc = wsMain.modules['categorySlider']._esc;
    let src = cat.imagem, srcset = '', sizes = '', w = 400, h = 400;
    try {
      const dims = wsMain.tools.imageDimensions.get(imgArea);
      if (dims) { w = dims.w; h = dims.h; }
    } catch (_) { }
    try {
      const resized = wsMain.tools.imageResize.attrs(src, imgArea);
      if (resized) { src = resized.src; srcset = resized.srcset; sizes = resized.sizes; }
    } catch (_) { }
    return `<img src="${esc(src)}"` +
      (srcset ? ` srcset="${esc(srcset)}" sizes="${esc(sizes)}"` : '') +
      ` alt="${esc(cat.nome)}" width="${w}" height="${h}" data-ws-img="${esc(imgArea)}" loading="lazy">`;
  },

  _card(cat, nameMode, imgArea) {
    const self = wsMain.modules['categorySlider'];
    const esc = self._esc;
    return `<a class="category-slider-card" href="${esc(cat.url)}" title="${esc(cat.nome)}" data-id="category-${esc(cat.id)}">` +
      `<div class="category-slider-photo">${self._photo(cat, imgArea)}</div>` +
      (nameMode != 'none' ? `<span class="category-slider-name">${esc(cat.nome)}</span>` : '') +
      '</a>';
  },

  create(items, elm) {
    // Nenhuma categoria com foto: a âncora fica como está — a seção (data-wsjs-container)
    // continua oculta.
    if (!items || items.length == 0) return;

    const self = wsMain.modules['categorySlider'];
    const options = wsMain.tools.getWsData(elm, 'options') || {};
    const useSlide = options.slide !== false && options.slide !== 'false';
    const nameMode = self._nameMode(options);
    const imgArea = options.imgArea || 'categories';
    const limit = parseInt(options.limit, 10);
    if (Number.isFinite(limit) && limit > 0) items = items.slice(0, limit);

    const holder = wsMain.tools.createElm({
      type: 'div',
      attrs: { class: 'category-slider-holder category-slider-name-' + nameMode + (useSlide ? '' : ' category-slider-grid') },
    });
    holder.innerHTML = items.map(c => self._card(c, nameMode, imgArea)).join('');

    // Anexa ANTES de montar o slide: createSlide() mede a largura do container (ver
    // wsapi3-manufacturers.js). visibility (não display) esconde a pintura crua sem tirar o
    // espaço do layout.
    wsMain.tools.replaceSpanTag(holder, elm);

    if (useSlide) {
      holder.style.visibility = 'hidden';
      const [slideSuccess, slider] = wsMain.tools.createSlide(holder, self.slideOptions(elm));
      if (slideSuccess && slider) {
        slider.update();
        // Setas no meio da foto: a altura dela depende da largura do slide (aspect-ratio). A
        // largura final só assenta depois (resize do replaceSpanTag, que não emite 'updated'),
        // então acompanha a própria foto.
        const photo = holder.querySelector('.category-slider-photo');
        const placeArrows = () => {
          if (photo && photo.offsetHeight) holder.style.setProperty('--cs-arrow-top', (photo.offsetHeight / 2) + 'px');
        };
        placeArrows();
        if (photo && typeof ResizeObserver != 'undefined') new ResizeObserver(placeArrows).observe(photo);
        else slider.on('updated', placeArrows);
      }
      holder.style.visibility = '';
    }

    return true;
  },
});
